

class Popup extends HTMLElement {
  constructor() {
    super();

    // this.overlay = document.getElementById('popupOverlay');
    // if (!this.overlay) {
    //   this.overlay = document.createElement('div');
    //   this.overlay.id = 'popupOverlay';
    //   this.overlay.textContent = ' ';
    //   this.overlay.style.display = 'none';
    //   this.overlay.classList.add('popupOverlay');
    //   document.documentElement.appendChild(this.overlay);
    //   window.addEventListener('load', () => {
    //     this.targetHeight = document.body.scrollHeight + 'px';
    //   });
    // }

    window.addEventListener("DOMContentLoaded", () => this.init());

    //this.outlistener = () => this.hide();
  }

  init() {
    if (this.dataset.for === undefined) return;

    this.triggerElements = document.querySelectorAll(this.dataset.for);
    if (!this.triggerElements.length) return;

    this.triggerElements.forEach(element => {
      element.addEventListener("mouseover", (event) => this.show(event));
      element.addEventListener("mouseout", (event) => this.hide(event));
    });

    this.addEventListener("mouseover", (event) => this.show(event));
    this.addEventListener('mouseout', (event) => this.hide(event));
  }

  show(event) {
    //console.log(event);
    if (!this.shown) {
      //this.overlay.style.minHeight = this.targetHeight;
      let left = event.pageX;
      if (this.dataset.minWidth) {
        const minWidth = parseInt(this.dataset.minWidth);
        if (document.body.scrollWidth - left < minWidth)
          left = document.body.scrollWidth - minWidth;
      }
      this.style.left = left + 'px';

      this.style.top = event.pageY + 'px';
      this.style.display = 'block';
      this.classList.add('active');
    }
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
//    this.overlay.addEventListener('click', this.outlistener);
    this.shown = true;
  }

  hide() {
    if (this.dataset.nohide !== undefined) return;
    this.hideTimeout = setTimeout(() => {
        this.classList.remove('active');
        this.hideTimeout = null;
        this.style.display = 'none';
        this.shown = false;
      },
      300);

    // this.overlay.style.minHeight = '0';
    // this.overlay.classList.remove('active');
    //this.classList.remove('active');
//    this.overlay.removeEventListener('click', this.outlistener);
  }


}

customElements.define('pop-up', Popup);



class ModalBox extends HTMLElement {
  constructor() {
    super();
    window.addEventListener("DOMContentLoaded", () => this.init());
    this.hideListener = (event) => this.hide(event);
  }

  init() {
    if (this.dataset.for === undefined) return;

    if (this.dataset.minWidth) {
      this.minWidth = parseInt(this.dataset.minWidth);
    }

    this.triggerElements = document.querySelectorAll(this.dataset.for);
    if (!this.triggerElements.length) return;

    this.overlay = document.getElementById('popupOverlay');
    if (!this.overlay) {
      this.overlay = document.createElement('div');
      this.overlay.id = 'popupOverlay';
      this.overlay.textContent = ' ';
      this.overlay.style.display = 'none';
      this.overlay.classList.add('popupOverlay');
      document.documentElement.appendChild(this.overlay);
      window.addEventListener('load', () => {
        this.overlay.style.minHeight = document.body.scrollHeight + 'px';
      });
    }

    this.triggerElements.forEach(element => {
      element.addEventListener("click", (event) => this.show(event));
      element.classList.add("modal-clickable");
    });

    this.x = this.querySelectorAll('.x, .modal-x');
    this.x.forEach(element => element.addEventListener('click', this.hideListener));

    this.overlay.style.minHeight = '100%';
  }

  show(event) {
    if (!this.shown) {
      this.overlay.style.minHeight = document.body.scrollHeight + 'px';
      this.overlay.style.display = 'block';
      this.style.display = 'block';

      let left = event.pageX;
      let top = event.pageY;
      if (this.minWidth) {
        if (document.body.scrollWidth < 750) {
          this.minWidth = Math.min(this.minWidth, 360);
        }
        // dont let it start more to the right than its width
        if (document.body.scrollWidth - left < this.minWidth + 20)
          left = document.body.scrollWidth - this.minWidth - 20;
      }

      if (document.body.scrollWidth < 750) {
        // horizontally center on mobile
        if (this.minWidth) {
          left = (document.body.scrollWidth - this.minWidth) / 2;
        }

        // make sure it doesnt span the fold when opened
        if (window.innerHeight < top - window.scrollY + this.scrollHeight) {
          top = window.innerHeight - this.scrollHeight - 20 + window.scrollY;
          if (top < window.scrollY + 20) top = window.scrollY + 20;
        }
      }
      this.style.left = left + 'px';
      this.style.top = top + 'px';

      setTimeout(() => {
        this.overlay.classList.add('active');
        this.classList.add('active');
        }, 0);

      this.overlay.addEventListener('click', this.hideListener);
      document.body.classList.add('modal-opened');
    }

    this.shown = true;
  }

  hide(event) {
    this.overlay.removeEventListener('click', this.hideListener);
    this.overlay.classList.remove('active');
    this.classList.remove('active');
    setTimeout(() => {
      this.overlay.style.display = 'none';
      this.style.display = 'none';
      }
      , 300);
    document.body.classList.remove('modal-opened');
    this.shown = false;
  }

}

/**
 * data-for: css selector for triggering elements
 *
 */

customElements.define('modal-box', ModalBox);
